import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import NativeUtil from '@utils/NativeUtil';

const AppTerminationModal: ActivityComponentType = () => {
  const { pop } = useFlow();
  const handleTermination = () => {
    NativeUtil.postMessage('terminateApp', '');
  };
  return (
        <Modal>
            <ModalContainer>
                <Column fullWidth align='center' spacing={42}>
                    <Text size='lg'>
                        APP을 종료하시겠습니까?
                    </Text>
                    <Row spacing={10}>
                        <Button variant='tertiary' onClick={pop}>취소</Button>
                        <Button onClick={handleTermination}>
                            확인
                        </Button>
                    </Row>
                </Column>
            </ModalContainer>
        </Modal>
  );
};

export default AppTerminationModal;
